export const SocialMediaPlatform = {
    Facebook: "Facebook",
    Youtube: "Youtube",
    Pinterest: "Pinterest",
    Twitter: "Twitter",
    Instagram: "Instagram",
  }